// The browser types a picked file from its extension; a File built in code has to be typed the same way.
export const CONTENT_TYPES_BY_EXTENSION: Record<string, string> = {
  '.txt': 'text/plain',
  '.csv': 'text/csv',
  '.pdf': 'application/pdf',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.png': 'image/png',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.msg': 'application/vnd.ms-outlook',
};

export const contentTypeFor = (fileName: string): string | undefined =>
  CONTENT_TYPES_BY_EXTENSION[`.${fileName.split('.').pop()}`.toLowerCase()];

// Browsers leave the type empty for extensions they do not know, such as Outlook .msg emails, and the
// upload URL request rejects an empty content type.
export const getContentTypeFor = (file: File): string =>
  file.type || contentTypeFor(file.name) || 'application/octet-stream';
